import { ref, watch } from 'vue'

const STORAGE_KEY = 'tableHideCompleted'

/**
 * Положение переключателя «Скрыть завершенные» (и его аналогов) по модулям, по тому же принципу, что useTableItemsPerPage.
 * Компонент выставляет значение в фильтры стора до создания useTableFilters: параметр из URL применяется позже и важнее.
 */
export function useTableHideCompleted(moduleName: string, defaultVal: boolean = false) {
  const getStoredValue = (): boolean => {
    try {
      const stored = localStorage.getItem(STORAGE_KEY)
      if (stored) {
        const parsed = JSON.parse(stored)
        if (parsed && typeof parsed === 'object' && parsed[moduleName] !== undefined) {
          return Boolean(parsed[moduleName])
        }
      }
    } catch (e) {
      console.error('Error reading hideCompleted from localStorage', e)
    }
    return defaultVal
  }

  const hideCompleted = ref<boolean>(getStoredValue())

  watch(hideCompleted, newVal => {
    try {
      const stored = localStorage.getItem(STORAGE_KEY)
      const parsed = stored ? JSON.parse(stored) : {}
      parsed[moduleName] = newVal
      localStorage.setItem(STORAGE_KEY, JSON.stringify(parsed))
    } catch (e) {
      console.error('Error writing hideCompleted to localStorage', e)
    }
  })

  return {
    hideCompleted,
  }
}
